var exports = {
  "DD": "xaf9ae18d--7a3f9a--title",
  "PS": "xaf9ae18d--7a3f9a--house",
  "VA": "xaf9ae18d--7a3f9a--subtitle",
};

module.exports = exports;
